import React, { useMemo, useState } from 'react'
import AppContext from './AppContext';
// import { IconContext, Horse, Heart, Cube } from "@phosphor-icons";

function AppProvider({ children }) {
  const [isLoading, setIsLoading] = useState(true);
  const [email, setEmail] = useState('');
  const [productList, setProductList] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [filtredList, setFiltredList] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState({});
  const [isLogged, setIsLogged] = useState(false);
  const [userData, setUserData] = useState({});
  const [gender, setGender] = useState('todos');
  const [category, setCategory] = useState('todas');
  const [listIndex, setListIndex] = useState(1);
  const [listSize, setListSize] = useState(10);

  const values = useMemo(() => ({
    isLoading,
    setIsLoading,
    email,
    setEmail,
    productList,
    setProductList,
    searchTerm,
    setSearchTerm,
    filtredList,
    setFiltredList,
    selectedProduct,
    setSelectedProduct,
    isLogged,
    setIsLogged,
    userData,
    setUserData,
    gender,
    setGender,
    category,
    setCategory,
    listIndex,
    setListIndex,
    listSize,
    setListSize,
  }), [
    isLoading,
    email,
    productList,
    searchTerm,
    filtredList,
    selectedProduct,
    isLogged,
    userData,
    gender,
    category,
    listIndex,
    listSize,
  ])


  return (
    <AppContext.Provider value={values}>
      {children}
    </AppContext.Provider>
  )
}

export default AppProvider